import SceDropDown from './dropDown';
import NotificationHelper from '../notificationHelper';
class SetUpTextDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Text: this.props.dropDownData.mobileSet,
      placeholder: !_.isEmpty(this.props.selectedValue) ? this.props.selectedValue : 'Enter Phone',
    };
  }
  componentWillMount() {
    this.getTextList(this.state.Text);
  }
  componentWillReceiveProps(nextProps) {
    this.getTextList(nextProps.dropDownData.mobileSet);
  }
  getTextList(textList) {
    let that = this;
    let selectedText = textList.filter((text) => {
      return text.value !== 'addText';
    });
    let textValueArr = selectedText.map((obj) => obj.telephoneNumber);
    let selectBoxTextList = selectedText.map(function (text, index) {
      let telephoneNumber = NotificationHelper.formatPhoneNumWithStar(text.telephoneNumber);
      return {
        name: telephoneNumber, value: telephoneNumber, encryptedPhoneNumber: text.encryptedPhoneNumber, type: text.type, indicatorSmsEnabled: text.indicatorSmsEnabled, indicatorTelephone: text.indicatorTelephone
      };
    });
    this.setState({ Text: selectBoxTextList }, () => { });
  }
  onAddPhoneConfirmDialogClick = (e, name, value, encVal) => {
    this.props.onModifyCustomerPreference('text', encVal, value);
  }
  onSelectDropDown = (e) => {
    var reqObj = { ...e };
    reqObj.id = this.props.id;
    this.props.onSelectDropDown(reqObj);
  }
  render() {
    return (
      <div>
        <SceDropDown
          id={'textNumberSelection_' + this.props.id + this.props.dropdownDiffererentiator}
          contactType={"text"}
          selectBoxData={this.state.Text}
          placeholder={this.state.placeholder}
          handleClick={this.onSelectDropDown}
          errorMessage={this.props.isSameValueError ? 'Primary and Secondary Contact details cannot be same.' : ''}
          selectErrorMessage={'Please select phone number'}
          isError={this.props.isSameValueError}
          triggerOnClick={this.props.triggerOnClick}
          onAddPhoneConfirmDialogClick={this.onAddPhoneConfirmDialogClick}
          inputButtonText={this.props.inputButtonText}
          addContactEncValueArr={this.props.addContactEncValueArr}
        />
      </div>
    );
  }
}

export default SetUpTextDropdown;
